import queryString from "query-string";
import { newSearchURL, checkParams } from "./index";
import { getData, __DBPATH__ } from "./../../services/db";

export const handleStepParam = (ev, stepParamURL, props) => {
  const { location } = props;
  const { pathname, search } = location;

  const paramsURL = queryString.parse(search);
  const actualStepValue = paramsURL[`step${stepParamURL}`];

  let newURL = newSearchURL(
    `step${stepParamURL}=${actualStepValue}`,
    `step${stepParamURL}=${ev.target.value}`,
    location
  );

  const newStepValue = `${pathname}${newURL}`;

  return newStepValue;
};

export const handleStep = (
  parentProps,
  stepParamURL,
  wizardData,
  steps,
  state
) => {
  if (state) {
    if (parentProps.stepParamURL !== state.stepParamURL) {

      
      if (wizardData && parseInt(stepParamURL) !== 1) {
        const stepIndex = parseInt(stepParamURL) - 2;        
        const stepURL = `${__DBPATH__}/steps/${steps[stepIndex].ID}`;
        const stepData = getData(stepURL);

        return stepData;
      }
    }
  } else {
    if (wizardData) {
      
      const stepIndex = parseInt(stepParamURL) - 2;

      const stepURL = `${__DBPATH__}/steps/${steps[stepIndex]}`;
      const stepData = getData(stepURL);

      return stepData;
    }
  }
};

export const handleIconValues = (
  stepParamURL,
  stepParamValue,
  props,
  selectedRowIconPrev
) => {
  const { location } = props;
  const { pathname } = location;

  let customStepParamURL = null;

  if (selectedRowIconPrev) {
    customStepParamURL = selectedRowIconPrev;
  } else {
    customStepParamURL = location && checkParams(stepParamURL, location);
  }

  let nextStep = null;

  if (customStepParamURL) {
    const newURL = newSearchURL(
      `${stepParamURL}=${customStepParamURL}`,
      `${stepParamURL}=${stepParamValue}`,
      location
    );
    nextStep = `${pathname}${newURL}`;
  } else {
    nextStep = `${pathname}${location.search}&${stepParamURL}=${stepParamValue}`;
  }

  return nextStep;
};
